import { BOARD_SIZE, Player, RowKind } from "./fundamentals";
import { wrapRow } from "./row";
import { wrapSquare } from "./square";
const forbiddenKinds = ["doubleThree", "doubleFour", "overline"];
export const ForbiddenKind = {
    doubleThree: "doubleThree",
    doubleFour: "doubleFour",
    overline: "overline",
};
export const forbiddens = (square) => new Array(BOARD_SIZE)
    .fill(null)
    .map((_, x) => new Array(BOARD_SIZE)
    .fill(null)
    .map((_, y) => {
    const p = [x, y];
    return [forbidden(square, p), p];
})
    .filter(([k, _]) => k !== undefined))
    .flat(1)
    .map(([k, p]) => [k, p]);
export const forbidden = (square, p) => {
    const next = wrapSquare(square).put(Player.black, p);
    if (overline(next, p)) {
        return ForbiddenKind.overline;
    }
    else if (doubleFour(next, p)) {
        return ForbiddenKind.doubleFour;
    }
    else if (doubleThree(next, p)) {
        return ForbiddenKind.doubleThree;
    }
};
const overline = (next, p) => {
    const newOverlines = next.rowsOn(Player.black, RowKind.overline, p);
    return newOverlines.length >= 1;
};
const doubleFour = (next, p) => {
    const newFours = next.rowsOn(Player.black, RowKind.four, p);
    if (newFours.length < 2)
        return false;
    return distinctive(newFours);
};
const doubleThree = (next, p) => {
    const newThrees = next.rowsOn(Player.black, RowKind.three, p);
    if (newThrees.length < 2 || !distinctive(newThrees))
        return false;
    const truthyThrees = newThrees.filter(r => forbidden(next.unwrap(), r.eye1) === undefined);
    if (truthyThrees.length < 2)
        return false;
    return distinctive(truthyThrees);
};
const distinctive = (rows) => {
    const first = wrapRow(rows[0]);
    for (const row of rows.slice(1)) {
        if (!first.adjacent(row))
            return true;
    }
    return false;
};
//# sourceMappingURL=forbidden.js.map